import type { Settings } from '../domain';

export function getSettings(): Settings | null {
  return window.settings;
}
